import { AnalyticsModelsTabs } from 'pages/Models/AnalyticsModelTab/AnalyticsModelsTabs';
import { AnalyticsModelDevelopment } from 'pages/Models/Development/AnalyticsModelDevelopment';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { ContextualPageProps } from 'utils/types';

export function AnalyticsPage({ corporation, location }: ContextualPageProps) {
    const { url } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${url}/repository/:modelId`}>
                <AnalyticsModelDevelopment
                    corporation={corporation}
                    location={location}
                />
            </Route>
            {/* @ts-expect-error: type issue with older version of react-router-dom */}
            <Route default>
                <AnalyticsModelsTabs corporation={corporation} location={location} />
            </Route>
        </Switch>
    );
}
